import Joi from "joi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Toast from "../../helpers/Toast";
import { ICountryDTO } from "../../models/Country/ICountryDTO";
import { ICountryCreateDTO } from "../../models/Country/ICountryCreateDTO";
import { CountryService } from "../../services/CountryService";
import useValidationSchema, {FieldConfig} from "../../components/Validations";

export default function CountryCreate() {
    const intl = useIntl();
    const countryService = new CountryService();
    const [loadingCreate, setLoadingCreate] = useState<boolean>(false);
    const [country, setCountry] = useState<ICountryDTO>({} as ICountryDTO);

    const navigate = useNavigate();

    const fields: FieldConfig[] = [
        ["name", "string", "Screens.Country.Validation.NameRequired"],
        ["iso2Code", "string", "Screens.Country.Validation.Iso2CodeRequired"],
        ["iso3Code", "string", "Screens.Country.Validation.Iso3CodeRequired"]
      ];

    const schemaClientValidation = useValidationSchema(fields);

    const createCountry = async () => {
        setLoadingCreate(true); 
    
        const { error } = schemaClientValidation.validate(country);
        
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoadingCreate(false); 
            return;
        }
    
        const createCountry: ICountryCreateDTO = {
            name: country.name,
            iso2Code: country.iso2Code,
            iso3Code: country.iso3Code
        };
    
        const response = await countryService.Create(createCountry);
    
        if (response.success !== true) {
            Toast.Show("error", response.message);
            setLoadingCreate(false); 
            return;
        }
    
        Toast.Show("success", response.message);
        setLoadingCreate(false); 
        navigate(-1); 
    };
    

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={intl.formatMessage({ id: "Screens.Country.CreateTitle" })} allowGoBack={true} />
                </div>
                <div className="pageBody">
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>Detalhes do País</b>
                    </label>
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Row>
                            <InputComponent
                                xl={6}
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={country?.name}
                                label={intl.formatMessage({ id: "Screens.Country.Info.Name" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setCountry({ ...country, name: t })
                                }}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={3}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={country?.iso2Code}
                                label={intl.formatMessage({ id: "Screens.Country.Info.Iso2Code" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setCountry({ ...country, iso2Code: t })
                                }}
                            />
                            <InputComponent
                                xl={3}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={country?.iso3Code}
                                label={intl.formatMessage({
                                    id: "Screens.Country.Info.Iso3Code",
                                })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setCountry({ ...country, iso3Code: t })
                                }}
                            />
                        </Row>
                    </Row>
                    <Row style={{ margin: "0px", marginTop: "10px", padding: "0px" }}>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                            <ButtonComponent
                                disabled={loadingCreate}
                                loading={loadingCreate}
                                text={intl.formatMessage({ id: "CountryCreate.Save" })}
                                onClick={createCountry}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
